import { AppRoleType } from '@/constants/role';

/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.AppCurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  return {
    canAdmin:
      currentUser?.roles?.some((role) => Number(role.type) === AppRoleType.System) ??
      false,
  };
}
